module.exports = __webpack_public_path__ + "static/media/undraw_growth_curve.85ccb561.svg";